export const dateToUTC = (date: Date) => {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
}

export const dateToString = (date: Date): string | undefined => {
  try {
    const year = date.getUTCFullYear()
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0')
    const day = date.getUTCDate().toString().padStart(2, '0')
    return `${year}-${month}-${day}`
  } catch (e) {
    console.warn('Error converting date to string:', e)
    return undefined
  }
}

/**
 * Get the placeholder format for the date given the format function
 * @param formatDate - The function to format the date
 * @returns The placeholder format
 */
export const getPlaceholderFormat = (
  formatDate: (v: Date) => string
): string => {
  // Use unique parts to replace with DD, MM, YYYY
  const reference = new Date('2025-11-22')
  const date = formatDate(reference)

  return (
    date
      .replace('22', 'DD')
      .replace('11', 'MM')
      .replace('2025', 'YYYY')
      // In case we use 2-digit year
      .replace('25', 'YY')
  )
}
